import { useEffect, useState } from 'react'

export const DocumentViewer = ({ base64 }) => {
  const [documentUrl, setDocumentUrl] = useState(null)

  useEffect(() => {
    console.log('📄 DocumentViewer received base64:', {
      hasBase64: !!base64,
      base64Length: base64?.length,
      startsWithDataPrefix: base64?.startsWith('data:'),
      first200Chars: base64?.substring(0, 200)
    })

    if (base64) {
      // Keep existing MIME type if present, otherwise assume PDF
      const hasDataPrefix = base64.startsWith('data:')
      const formattedBase64 = hasDataPrefix ? base64 : `data:application/pdf;base64,${base64}`

      console.log('📄 Formatted document URL:', {
        hasDataPrefix,
        urlLength: formattedBase64.length,
        urlStart: formattedBase64.substring(0, 50)
      })

      setDocumentUrl(formattedBase64)
    }
  }, [base64])

  console.log('📄 DocumentViewer render:', {
    hasDocumentUrl: !!documentUrl,
    documentUrlLength: documentUrl?.length
  })

  if (!documentUrl) {
    console.log('📄 DocumentViewer: No document URL, returning null')
    return null
  }

  return <iframe src={documentUrl} width='100%' height={1080} title='Document Viewer' style={{ border: 'none' }} />
}
